<template>
  <div class="main">
    <c-panel title="Motorista" titleIcon="fas fa-id-badge">
      <form-motorista :paramId="id" @onSubmitMotorista="afterSubmit"></form-motorista>
    </c-panel>
  </div>
</template>

<script>
import formMotorista from "./form"

export default {
  components: { formMotorista },
  computed: {
    id () { return this.$route.params.id }
  },
  methods: {
    afterSubmit () { this.$router.push('/admin/transporte/motorista') }
  }
}
</script>

